module.exports = __webpack_public_path__ + "static/media/linkedin.24e21102.svg";